<footer>
  <div class="footer-content">
    <img 
      src="assets/translate-logo-not-collapsed.svg" 
      alt="AZ Translate" 
      class="footer-logo"
    />
    <p class="footer-description">
      AZ Translate Vendor Translation Services provide reliable and culturally accurate translations to support 
      global communication across teams and markets. With a network of certified linguist vendors and 
      advanced language technology, AZ Translate ensures your content is professionally localized, maintaining 
      clarity and consistency across languages.
    </p>
  </div>
  <br/>
  <p class="footer-version">
    Translate-quotes-dev Version: 0.0.1 AstraZeneca 2026
  </p>
</footer>
